import { render, staticRenderFns } from "./RelatedReading.vue?vue&type=template&id=22dd9fca&scoped=true&"
import script from "./RelatedReading.vue?vue&type=script&lang=js&"
export * from "./RelatedReading.vue?vue&type=script&lang=js&"
import style0 from "./RelatedReading.vue?vue&type=style&index=0&id=22dd9fca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd9fca",
  null
  
)

export default component.exports